import { media } from "src/styles/mixins";
import styled, { css } from "styled-components";

export const CardDescription = styled.div`
  margin-top: 4px;
  font-size: ${({ theme }) => theme.fonts.sizes.xxs};
  line-height: ${({ theme }) => theme.fonts.lineHeights.xxs};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 40px;

  ${media.up("MOBILE")`
    max-width:75px;
  `}

  text-align: center;

  @media ${({ theme }) => theme.mq.md} {
    font-size: ${({ theme }) => theme.fonts.sizes.base};
    line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  }
`;

export const UsernameCardWrapper = styled.div<{ isSummary?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;

  ${({ isSummary }) =>
    isSummary &&
    css`
      flex-direction: row;
      align-items: flex-end;
    `}
`;
